//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import TableComponent from '../../../components/TableComponent/TableComponent.vue'
import ReportMaterialsImageBtn from './ReportMaterialsImageBtn.vue'
import { buildAvailableMaterialsTableItems } from './ReportMaterialsHelperFunctions.js'

export default {
  components: {
    TableComponent,
    ReportMaterialsImageBtn
  },
  props: {
    materialesAvailable: {
      type: Array,
      default () {
        return []
      }
    },
    standardSpecificationsByReport: {
      type: Object,
      default () {
        return {}
      }
    },
    reports: {
      type: Array,
      default () {
        return null
      }
    }
  },
  data: function () {
    return {
      filterBySpecification: false
    }
  },
  computed: {
    hasAnySpecification: function () {
      const map = this.standardSpecificationsByReport || {}
      return Object.keys(map).some(reportId => (map[reportId] || []).length > 0)
    },
    tableItems: function () {
      return buildAvailableMaterialsTableItems(this.materialesAvailable, this.standardSpecificationsByReport)
    },
    filteredTableItems: function () {
      if (!this.filterBySpecification) {
        return this.tableItems
      }
      return this.tableItems.filter(row => row.standards && row.standards.length)
    },
    columnsMaterialesAvailable: function () {
      const columns = [
        {
          name: 'toolName',
          label: 'Название',
          align: 'left',
          field: 'toolName',
          classes: 'class-bordered',
          sortable: true
        },
        {
          name: 'toolKey',
          label: 'ID номенклатурной позиции в 1С',
          align: 'left',
          field: 'toolKey',
          classes: 'class-bordered',
          sortable: true
        },
        {
          name: 'amount',
          label: 'Кол-во (доступное)',
          align: 'left',
          field: 'amount',
          classes: 'class-bordered',
          format: this.formatAmountMaterialesTable,
          sortable: true
        },
        {
          name: 'unit',
          label: 'Ед. изм.',
          align: 'left',
          field: 'unit',
          classes: 'class-bordered',
          sortable: true
        },
        {
          name: 'stockName',
          label: 'Склад',
          align: 'left',
          field: 'stockName',
          classes: 'class-bordered',
          format: (stockName, row) => this.formatStockNameMaterialesTable(stockName, row),
          sortable: true
        },
        {
          name: 'reserve',
          label: 'Резерв',
          align: 'left',
          field: 'reserve',
          classes: 'class-bordered',
          sortable: true
        },
        {
          name: 'block',
          label: 'Блокировка',
          align: 'left',
          field: 'block',
          classes: 'class-bordered',
          sortable: true
        }
      ]
      if (this.hasAnySpecification) {
        columns.push(
          {
            name: 'inSpecification',
            label: 'Типовая спецификация',
            align: 'left',
            field: 'standards',
            classes: 'class-bordered',
            sortable: false,
            format: this.formatInSpecification
          },
          {
            name: 'standardCount',
            label: 'Типовое количество',
            align: 'left',
            field: 'standards',
            classes: 'class-bordered',
            sortable: false,
            format: this.formatStandardCounts
          },
          {
            name: 'standardProject',
            label: 'Типовой проект',
            align: 'left',
            field: 'standards',
            classes: 'class-bordered',
            sortable: false,
            format: this.formatStandardProjects
          }
        )
      }
      return columns
    }
  },
  methods: {
    getReportName: function (reportId) {
      if (this.reports && this.reports.length) {
        const report = this.reports.find(r => r.id === reportId || String(r.id) === String(reportId))
        if (report) {
          return report.name
        }
      }
      return null
    },
    formatInSpecification: function (row) {
      if (!row.standards || !row.standards.length) {
        return 'Нет'
      }
      if (this.reports && this.reports.length > 1) {
        const names = row.standards.map(s => this.getReportName(s.reportId) || s.reportId)
        return names.join(', ')
      }
      return 'Да'
    },
    formatStandardCounts: function (row) {
      if (!row.standards || !row.standards.length) {
        return ''
      }
      return row.standards.map(s => {
        const count = s.count != null ? s.count : 'Нет данных'
        if (this.reports && this.reports.length > 1) {
          const name = this.getReportName(s.reportId)
          return name ? (count + ' (' + name + ')') : count
        }
        return count
      }).join(', ')
    },
    formatStandardProjects: function (row) {
      if (!row.standards || !row.standards.length) {
        return ''
      }
      return row.standards.map(s => {
        const projectName = s.project && s.project.name ? s.project.name : 'Нет данных'
        if (this.reports && this.reports.length > 1) {
          const name = this.getReportName(s.reportId)
          return name ? (projectName + ' (' + name + ')') : projectName
        }
        return projectName
      }).join(', ')
    },
    formatStockNameMaterialesTable: function (stockNames, row) {
      if (stockNames && stockNames.length) {
        return stockNames.map(stock => stock + (row.isArchive && row.isArchive[stockNames.indexOf(stock)] ? ' (архивный)' : ''))
      } else {
        return 'Нет данных'
      }
    },
    formatAmountMaterialesTable: function (amount) {
      if (amount && amount.length) {
        let sumAmount = ''
        for (let i = 0; i < amount.length; i++) {
          if (i === 0) {
            sumAmount = amount[i]
          } else {
            sumAmount += ', ' + amount[i]
          }
        }
        return sumAmount
      } else {
        return '0'
      }
    }
  }
}

